<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title font-weight-normal">
        {{ $t("net_revenue_report") }}
      </div>
      <small><em>{{ $t("* As Per show Date/Transaction Date") }}</em></small>
      <div class="mt-3 mb-2">
        <div class="row">

         

          <div class="col-lg-4 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.selectedCinema ? 'shift-up' : 'font-weight-bold'
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema"
                :allowEmpty="true"
                :showLabels="false"
                :multiple="true"
                :close-on-select="true"
                :limit="2"
                :limit-text="(count) => `& +${count} More`"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="filter_key_array.length > 0 ? 'shift-up' : ''">
                 {{ $tc(" Data For", 1) }}
              </label>

              <multiselect v-model="filter_value" :allowEmpty="true" :disabled="isRoleID" :options="filter_key_array"
                :searchable="true" :showLabels="false" placeholder="Filter"
                   
               >
              </multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button v-if="fromDate" class="btn-clearDate">✖</button> -->
                <Datepicker ref="programaticOpen" v-model="fromDate" v-validate="'required'" :monday-first="true"
                  type="date" @selected="onChangeDate($event, 'from')"></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("from") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button v-if="toDate" class="btn-clearDate">✖</button> -->
                <Datepicker ref="programaticOpen" v-model="toDate" v-validate="'required'" :monday-first="true">
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("to") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-1 col-xl-1 align-self-center mb-2">
            <button class="btn-blue-lg w-100" @click.prevent="getNetRevReport({ isPdf: 'N', isExcel: 'N' })">
              {{ $t("FETCH") }}
            </button>
          </div>

          <div v-if="getReportList.length > 0"
            class="col-lg-12 col-xl-12 align-self-center mt-2 d-flex justify-content-end">
            <span download style="cursor: pointer" title="Download as Pdf"
              @click="getNetRevReport({ isPdf: 'Y', isExcel: 'N' })">
              <img height="25" src="@/assets/img/icons/pdf.svg" width="25" />
            </span>
            <span download style="cursor: pointer" title="Download as Excel"
              @click="getNetRevReport({ isPdf: 'N', isExcel: 'Y' })">
              <img height="25" src="@/assets/img/icons/excel.svg" width="25" />
            </span>
          </div>
        </div>
      </div>

      <div>
        <div class="table-scroll">
          <table border="1" class="swc-report-table">
            <thead >
              <tr class="font-weight-bold">
                <th rowspan="2">Cinema Name</th>
                <th colspan="4">Net Sales</th>
              </tr>
              <tr class="font-weight-bold">
                <th>Ticket</th>
                <th>3D</th>
                <th>FnB</th>
                <th>DTA & Others</th>
              </tr>
            </thead>
            <tbody v-if="getReportList.length > 0">
              <tr v-for="(reportData, reportDataIndex) in getReportList" :key="reportDataIndex">
                <td class="text-left">
                  {{ reportData.cinema_name }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_net) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_3d) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_fnb_net) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_dta_net || 0) }}
                </td>
              </tr>

              <tr v-for="(reportData, reportDataIndex) in grandTotal" :key="reportDataIndex"
                class="font-weight-bold">
                <td class="text-left">
                  {{ reportData.cinema_name }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_net) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_3d) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_fnb_net) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_dta_net || 0) }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="13">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import NewReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import * as XLSX from "xlsx";

export default {
  name: "NetRevenueReport",
  components: {
    NoRecords,
  },
  data() {
    return {
      isExcel: "N",
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: moment().toDate(),
      toDate: new Date(),
      filter_key_array: ["Show Date", "Transaction Date"],
      filter_value: "Transaction Date",
      grandTotal: [],
      getReportList: [],
      selectedCinema: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    const { cinema_id } = this.secureStore.get("USINFO");
    this.getCinemaList(cinema_id);
    if (CinemaObj) {
      if (CinemaObj.cine_id != "all") {
        this.onSelectCinema(CinemaObj);
      }
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        if (CinemaObj.cine_id != "all") {
          this.onSelectCinema(CinemaObj);
        }
      }
    },
  },
  computed: {},
  mounted() { },
  methods: {
    moment,
    onChangeDate(e, type) {
      console.log("onChangeDate", type);
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    getNetRevReport({ isPdf = "N", isExcel = "N" }) {
      this.submitted = true;
      this.getReportList = [];
      this.grandTotal = [];

      // if (!this.dropDown.selectedCinemaId) {
      //   this.$toasted.show(`Please Select Cinema`);
      //   return false;
      // }

      // let selectedCinemaId =
      //   this.dropDown.selectedCinemaId == 0
      //     ? this.CinemasCopy.map((x) => {
      //       return x.cine_id;
      //     })
      //     : [this.dropDown.selectedCinemaId];

      if (!this.fromDate) {
        return this.$toasted.show("From Date field cannot be empty");
      }
      if (!this.toDate) {
        return this.$toasted.show("To Date field cannot be empty");
      }
      if (moment(this.fromDate).isAfter(moment(this.toDate))) {
        return this.$toasted.show("To date should be greater than from date");
      }

      let loader = this.$loading.show();

       let cinemaIds = [];
          let cinema_name = "";
          let cinema_address = "";

          if (this.selectedCinema.length) {
            if (this.selectedCinema[0].cine_id === 0) {
              cinemaIds = this.CinemasCopy.map((cinema) => cinema.cine_id);
              cinema_name = "All Cinema";
              cinema_address = "";
            } else {
              cinemaIds = this.selectedCinema.map((cinema) => cinema.cine_id);
              if (this.selectedCinema.length === 1) {
                cinema_name = this.selectedCinema[0].cine_name || "";
                cinema_address = this.selectedCinema[0].cine_address || "";
              } else {
                cinema_name = this.selectedCinema
                  .map((cinema) => cinema.cine_name)
                  .join(", ");
                cinema_address = this.selectedCinema
                  .map((cinema) => cinema.cine_address)
                  .filter((addr) => addr)
                  .join(", ");
              }
            }
          }

      let payload = {
        cinema_id: cinemaIds,
            cinema_name: cinema_name,
            cinema_address: cinema_address,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        excel: isExcel,
        isPdf: isPdf,
        is_filter_show_date: this.filter_value == "Show Date",
      };

      NewReportsService.GetNewRevenueReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.getReportList = [...data.Records];
            this.grandTotal = [...(data.GrandTotal || [])];
          } else {
            this.$toasted.show(data.message);
          }
          if (data.excelUrl && isExcel == "Y") {
            window.open(data.excelUrl, "_blank");
          } else if (data.pdfPath && isPdf == "Y") {
            window.open(data.pdfPath, "_blank");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((e) => {
          console.log("GetNewRevenueReport Error", { e });

          this._CatchError(e);
        })
        .finally(() => {
          loader.hide();
        });
    },
     getCinemaList: function(cinema_id) {
           MasterService.GetCinemasByRoles()
             .then((response) => {
               const { data } = response;
               if (data.status && data.Records.length > 0) {
                if(cinema_id) {
                   this.dropDown.cinemas = [
                   ...data.Records,
                 ];
                } else {
                  this.dropDown.cinemas = [
                   { cine_id: 0, cine_name: "All Cinema" },
                   ...data.Records,
                 ];
                }
                this.CinemasCopy = data.Records;
               } else {
                 this.$toasted.show(data.message);
               }
             })
             .catch(this._CatchError);
         },
    onSelectCinema: function(event) {
        this.selectedCinema = event;

        if (event.length > 0) {
          if (event[event.length - 1].cine_name == "All Cinema") {
            this.dropDown.cinemas = this.dropDown.cinemas.map((cinema) => ({
              ...cinema,
              $isDisabled: true,
            }));
            // Enable "All Cinema" option
            const allCinema = this.dropDown.cinemas.find(
              (cinema) => cinema.cine_name == "All Cinema"
            );
            if (allCinema) {
              allCinema.$isDisabled = false;
            }
            console.log("1");
          } else {
            this.dropDown.cinemas = this.dropDown.cinemas.map((cinema) => ({
              ...cinema,
              $isDisabled: cinema.cine_name == "All Cinema",
            }));
            console.log("2");
          }
        } else {
          this.dropDown.cinemas = this.dropDown.cinemas.map((cinema) => ({
            ...cinema,
            $isDisabled: false,
          }));
          console.log("3");
        }
      },
  },
  beforeDestroy: async function () {
    // remove file
  },
};
</script>

<style scoped>

.swc-report-table td{
   word-wrap: break-word; 
  overflow-wrap: break-word;
  font-size: 12px;
   /* padding: 4px 6px;   
  line-height: 1.2; */
}

thead tr th{
  font-size: 12px;
  /* padding: 4px 6px;   
  line-height: 1.2; */
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/NetRevenueReport.vue